class AwaitableEventEmitter {
  constructor() {
    this.key = 0;
    this._listeners = /* @__PURE__ */ Object.create(null);
    this._once = /* @__PURE__ */ Object.create(null);
  }
  on(listener) {
    const key = this.key++;
    this._listeners[key] = listener;
    const listeners = this._listeners;
    return function unsubscribe() {
      delete listeners[key];
    };
  }
  once(listener) {
    const key = this.key++;
    this._listeners[key] = listener;
    this._once[key] = true;
    const listeners = this._listeners;
    return function unsubscribe() {
      delete listeners[key];
    };
  }
  async emit(eventData) {
    const keys = Object.keys(this._listeners);
    const promises = keys.map(async (key) => {
      const listener = this._listeners[key];
      if (this._once[key]) {
        delete this._listeners[key];
      }
      try {
        await listener(eventData);
      } catch (err) {
        return Promise.reject(err);
      }
    });
    await Promise.allSettled(promises);
    return eventData;
  }
  listeners() {
    return Object.values(this._listeners);
  }
}
export {
  AwaitableEventEmitter
};
//# sourceMappingURL=awaitable-event-emitter.js.map
